import { Text } from '@adc/parallax-component-library';

import { useModal } from '~/features/modals/useModal';

import { Modal } from '../Modal';

type AdminUserEditModalProps = {
  testID: string;
};

export const AdminUserEditModal = ({ testID }: AdminUserEditModalProps) => {
  const { closeModal } = useModal();

  return (
    <Modal
      title="User Details"
      testID={testID}
      hasCloseButton
      size="l"
      primaryAction={{
        label: 'Done',
        onPress: () => {
          closeModal('AdminUserEdit');
        },
      }}
      onOpenChange={() => {
        closeModal('AdminUserEdit');
      }}
    >
      <Text type="$bodyBase.default">To be implemented</Text>
    </Modal>
  );
};
